function matchLeaf(cond, answers) {
    if (!cond || !cond.fieldKey) return true;
    const val = answers ? answers[cond.fieldKey] : undefined;
    if (Object.prototype.hasOwnProperty.call(cond, 'equals')) return val === cond.equals;
    if (cond.in) return cond.in.includes(val);
    if (Object.prototype.hasOwnProperty.call(cond, 'notEquals')) return val !== cond.notEquals;
    return true;
}

// A condition can be:
//  - a single leaf { fieldKey, equals | in | notEquals }
//  - an array of leaves, treated as OR (legacy shorthand)
//  - { any: [cond, ...] } — OR of nested conditions
//  - { all: [cond, ...] } — AND of nested conditions
function evalCondition(cond, answers) {
    if (!cond) return true;
    if (Array.isArray(cond)) return cond.some((c) => evalCondition(c, answers));
    if (cond.any) return cond.any.some((c) => evalCondition(c, answers));
    if (cond.all) return cond.all.every((c) => evalCondition(c, answers));
    return matchLeaf(cond, answers);
}

// A field with no showIf is always visible.
export function isFieldVisible(field, answers) {
    if (!field || !field.showIf) return true;
    return evalCondition(field.showIf, answers);
}

export function groupFieldsBySteps(fields, steps) {
    if (!steps || steps.length === 0) {
        return [{ stepKey: '__all__', title: null, fields: fields || [] }];
    }
    return steps.map((step) => ({
        stepKey: step.stepKey,
        title: step.title,
        fields: (fields || []).filter((f) => f.stepKey === step.stepKey),
    })).filter((group) => group.fields.length > 0);
}
